import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import classNames from "classnames";
import { memo } from "react";
import * as styles from "./logistics-product-summary.module.css";

export const LogisticsProductSummary = memo(function LogisticsProductSummary({
  title,
  description,
  productEnabled,
  setProductEnabled,
}: {
  title: string;
  description: string;
  productEnabled: boolean;
  setProductEnabled: (productEnabled: boolean) => void;
}) {
  return (
    <Flex
      align="stretch"
      className={styles.container}
      dir="column"
      gap="none"
      px="xl"
    >
      <Flex align="stretch" dir="column" gap="none">
        <Flex dir="row" gap="xl" py="xl">
          <Flex align="center" dir="column" gap="none" justify="flex-start">
            <RedoToggle
              onClick={(e) => e.stopPropagation()}
              semantic
              setValue={setProductEnabled}
              size="sm"
              value={productEnabled}
            />
          </Flex>
          <Flex align="stretch" dir="column" gap="xs" grow={1}>
            <Text fontSize="sm" fontWeight="medium" textColor="primary">
              {title}
            </Text>
            <Flex dir="row" gap="xxs">
              <div
                className={classNames(
                  styles.statusLight,
                  productEnabled ? styles.enabled : styles.disabled,
                )}
              />
              <Flex align="stretch" dir="column" gap="none">
                <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
                  {productEnabled ? "Enabled" : "Disabled"}
                </Text>
                <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
                  {description}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});
